import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles.css'
import * as FcIcons from 'react-icons/fc';
import { useForm } from 'react-hook-form';
import { Modal, Button } from "react-bootstrap";

import AxiosService from "../services/axios.service";
import AuthService from "../services/auth.service";
const API_PATH = "contacts";

function List(match) {
  const { path } = match;
  const [contacts, setContacts] = useState(null);
  const [results, setResults] = useState(0);
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const { register, watch, formState: { errors }, handleSubmit } = useForm();
  const [deleteId, setDeleteId] = useState(0);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    console.log("close");
  };

  const confirmDelete = (id) => {
    setShow(true);
    setDeleteId(id);
  };

  function deleteContact() {
    console.log("deleting contact id: " + deleteId);
    setContacts(contacts.map(x => {
      if (x.id === deleteId) { x.isDeleting = true; }
      return x;
    }));
    AxiosService.delete(API_PATH, deleteId).then(() => {
      setContacts(contacts => contacts.filter(x => x.id !== deleteId));
    });
    setShow(false);
  };
  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.getAll(API_PATH).then(x => {
      setContacts(x.data);
      setResults(x.data.length);
    }
    );
  }, []);

  function search() {
    var keyword = watch("query").toLowerCase();
    console.log("keyword: " + keyword);
    AxiosService.getAll(API_PATH).then(x => {
      console.log(JSON.stringify(x.data));
      var queries = x.data.filter(item => item.title.toLowerCase().includes(keyword) || item.name.toLowerCase().includes(keyword) || item.agency_name.toLowerCase().includes(keyword))
      setContacts(queries)
      setResults(queries.length)
    }
    );
  }


  return (
    <div>
      <h1>Agency Contacts</h1>
      {(mod || admin) && (
        <Link to={`/contacts/add`} className="btn btn-sm btn-success mb-2"> Add Contact </Link>
      )}
      <form onSubmit={handleSubmit(search)} onReset={useEffect}>
        <div className="form-row">
          <div className="form-group col-5">
            <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
            <div className="invalid-feedback">{errors.query?.message}</div>
          </div>
          <div className="form-group col-5">
            {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
            <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
          </div>
        </div>
      </form>
      <text>Results: {results}</text>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: '20%' }}>Title</th>
            <th style={{ width: '20%' }}>Contact Name</th>
            <th style={{ width: '20%' }}>Address</th>
            <th style={{ width: '20%' }}>Phone</th>
            <th style={{ width: '20%' }}>Details</th>
          </tr>
        </thead>
        <tbody>
          {contacts && contacts.map(contact =>
            <tr key={contact.id}>
              <td>{contact.title}</td>
              <td>{contact.name}</td>
              <td>{contact.street_address} {contact.city} {contact.state} {contact.zip}</td>
              <td>{contact.primary_phone}</td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <Link to={`/contacts/view/${contact.id}`} className="btn btn-sm btn-info mr-2"> View </Link>
                {(mod || admin) && (
                  <Link to={`/contacts/edit/${contact.id}`} className="btn btn-sm btn-primary mr-2"> Edit </Link>
                )}
                {admin && (
                  <button
                    className="btn btn-sm btn-danger mr-2"
                    onClick={() => confirmDelete(contact.id)}
                  >
                    Delete
                  </button>
                )}
              </td>
            </tr>
          )}
          {!contacts &&
            <tr>
              <td colSpan="4" className="text-center">
                <div className="spinner-border spinner-border-lg align-center"></div>
              </td>
            </tr>
          }
          {contacts && !contacts.length &&
            <tr>
              <td colSpan="4" className="text-center">
                <div className="p-2">No Users To Display</div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Would you like to delete this Contact?</Modal.Body>
        <Modal.Footer>

          <Button variant="secondary" onClick={() => deleteContact(deleteId)}>
            OK
          </Button>

          <Button variant="primary" onClick={handleClose}>
            Cancel
          </Button>

        </Modal.Footer>
      </Modal>

    </div>
  );
}

export { List };